import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {OrderAssignmentRuleEntityModel} from "../order-assignment-rule-entity.model";
import {MetaTagType} from "../../../catalogue/meta-tag/meta-tag.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-order-assignment-rule-edit-page",
    templateUrl: "./order-assignment-rule-edit-page.component.html",
    providers: [provideEntityModel(OrderAssignmentRuleEntityModel)]
})
export class OrderAssignmentRuleEditPageComponent extends AbstractEditPage {
    MetaTagType = MetaTagType;

    constructor(public model: OrderAssignmentRuleEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
